import { Injectable } from '@angular/core';
import { DropdownItem } from 'mis-crystal-design-system/dropdown';

interface RouteSelectionState {
  selectedDate: string;
  selectedShift: DropdownItem;
  selectedDirections: DropdownItem[];
  selectedRoutes: DropdownItem[];
  allRoutes: any[];
}

@Injectable({
  providedIn: 'root'
})
export class RouteSelectionStateService {
  private state: RouteSelectionState = {
    selectedDate: '',
    selectedShift: { label: '', value: '' },
    selectedDirections: [],
    selectedRoutes: [],
    allRoutes: []
  };

  saveState(state: Partial<RouteSelectionState>): void {
    this.state = { ...this.state, ...state };
  }

  getState(): RouteSelectionState {
    return { ...this.state };
  }

  clearState(): void {
    this.state = {
      selectedDate: '',
      selectedShift: { label: '', value: '' },
      selectedDirections: [],
      selectedRoutes: [],
      allRoutes: []
    };
  }

  hasState(): boolean {
    return !!(this.state.selectedDate && this.state.selectedShift.value);
  }
}
